import { render, staticRenderFns } from "./ConvertIds.vue?vue&type=template&id=67255b0d"
import script from "./ConvertIds.vue?vue&type=script&lang=js"
export * from "./ConvertIds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports